import { chain } from '@leprecoins/effector';
import { combine, createEvent, createStore, sample } from 'effector';
import { createGetGamesCashierQuery } from 'shared/api';
import { gameRoute } from 'shared/routing';

export const getGamesCashierQuery = createGetGamesCashierQuery();

const $games = getGamesCashierQuery.$data.map((result) => result?.rows ?? []);

export const $activeGame = createStore<number | null>(null);

const $gameName = combine(
	{
		gameId: $activeGame,
		games: $games,
	},
	({ gameId, games }) => games.find((game) => Number(game.id) === gameId)?.title ?? '',
);

const { $pending } = getGamesCashierQuery;

const setActiveGame = createEvent<number | null>();

chain(setActiveGame, $activeGame);

sample({
	clock: getGamesCashierQuery.finished.success,
	source: gameRoute.$query,
	fn: (query, { result }) =>
		'id' in query && Number(query.id) && result.rows.find((game) => game.id === Number(query.id))
			? Number(query.id)
			: (result.rows[0]?.id ?? null),
	target: $activeGame,
});

export const gameAsideModel = {
	$games,
	$activeGame,
	$gameName,
	$pending,
	setActiveGame,
	getGamesCashierQuery,
};
